import React from 'react';

import PropTypes from 'prop-types';

import CarrierListItem from './CarrierListItem';

import styles from './CarrierList.scss';

function CarrierList(props) {
    const {
        data,
        namespace,
    } = props;

    return (
        <ul className={styles.root}>
            {data.map((carrierData) => (
                <CarrierListItem
                    carrierData={carrierData}
                    key={carrierData.carrierCode}
                    namespace={namespace}
                />
            ))}
        </ul>
    );
}

CarrierList.propTypes = {
    namespace: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CarrierList;
